import merge from 'classnames';

import { SimpleIconProps } from '../types';

import colors from 'styles/core/colors.module.scss';

export const IconInformation = ({
  id,
  className,
  color = colors.COLOR_light_grey,
  size = '26',
}: SimpleIconProps) => (
  <svg
    className={merge(className)}
    fill={color}
    height={size}
    id={id}
    role="img"
    viewBox="0 0 28 28"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.6665 19.334H15.2227V12.6949H12.6665V19.334Z" fill={color} />
    <path d="M12.6665 11.3669H15.2227V8.71128H12.6665V11.3669Z" fill={color} />
    <path
      clipRule="evenodd"
      d="M27.3332 14.0007C27.3332 6.63685 21.3636 0.667316 13.9998 0.667316C6.63604 0.667316 0.666504 6.63685 0.666504 14.0007C0.666504 21.3644 6.63604 27.334 13.9998 27.334C21.3636 27.334 27.3332 21.3644 27.3332 14.0007ZM24.6665 14.0007C24.6665 8.10961 19.8909 3.33398 13.9998 3.33398C8.1088 3.33398 3.33317 8.10961 3.33317 14.0007C3.33317 19.8917 8.1088 24.6673 13.9998 24.6673C19.8909 24.6673 24.6665 19.8917 24.6665 14.0007Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);
